var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoxel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.038 1.01V1l-.032.004A2.325 2.325 0 0 0 15.974 1v.01c-.507.08-1.41.392-1.41 1.08 0 .718.513 1.025.77 1.09-.086.448-.27 1.46-.321 1.923-.051.461-.021 1.09 0 1.346l-4.744 2.178.448.898c1.358-.753 4.265-2.204 5.256-2.124v.008a.702.702 0 0 1 .032-.004c.011 0 .022.003.032.004v-.008c.991-.08 3.899 1.371 5.257 2.124l.449-.898L17 6.448c.021-.256.051-.884 0-1.345-.051-.462-.235-1.475-.32-1.924.256-.065.769-.372.769-1.09-.001-.688-.904-1-1.412-1.08zm-1.474 9.093c-1.41.576-4.513 1.91-5.64 2.628-.13.083-.252.16-.366.23C7.423 13.674 7 13.94 7 15.104v3.974c0 1.282 1.86 6.154 4.36 8.846 1.943 2.093 3.842 2.903 4.614 3.065V31a1.73 1.73 0 0 0 .032-.006l.032.006v-.012c.773-.162 2.672-.972 4.616-3.065 2.5-2.692 4.359-7.564 4.359-8.846v-3.974c0-1.165-.423-1.43-1.558-2.142a62.507 62.507 0 0 1-.365-.23c-1.128-.717-4.23-2.05-5.641-2.627l.768 12.564-2.212 4.044-2.211-4.043.77-12.564z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoxel);
export default __webpack_public_path__ + "static/media/VOXEL.26daff5189ee26f724583ca3b5960294.svg";
export { ForwardRef as ReactComponent };